export default __webpack_public_path__ + "static/media/gear.3f88a6ba.svg";